import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import {
  applicationContextActions,
  applicationContextMutations,
  applicationContextState
} from './index';

export default {
  namespaced: true,
  state: applicationContextState,
  mutations: applicationContextMutations,
  actions: applicationContextActions
} as ModuleTree<RootState>;
